import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '15px 0',
      gap: '15px',
    },
    checkboxLabel: {
      fontSize: '14px',
    },
    termsLink: {
      color: 'rgba(41, 121, 255, 0.87)',
    },
    amountToWithdraw: {
      cursor: 'pointer',
      color: 'rgba(41, 121, 255, 0.87)',
    },
    actions: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '15px',
      fontWeight: 400,
      fontSize: '22px',
    }
  }
))
